// VetTableRow.jsx
import React from "react";
import GeneralTableColumn from "../../../Components/GeneralTableColumn";

export default function VetTableRow({ vet, portal }) {
  // Helper to map numeric codes
  const getStatus = (status) => {
    if (status === 1) return "Opted Out";
    if (status === 2) return "No Campaign";
    return "Active";
  };

  return (
    <>
      <GeneralTableColumn>{vet.business_name}</GeneralTableColumn>
      <GeneralTableColumn>{vet.formatted_address}</GeneralTableColumn>
      <GeneralTableColumn>{vet.email}</GeneralTableColumn>
      <GeneralTableColumn>{vet.phone}</GeneralTableColumn>
      <GeneralTableColumn>
        {vet.supplier_website ? (
          <a
            href={
              vet.supplier_website.startsWith("https")
                ? vet.supplier_website
                : `https://${vet.supplier_website}`
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            {vet.supplier_website}
          </a>
        ) : (
          "N/A"
        )}
      </GeneralTableColumn>

      {portal !== "outreach" && (
        <>
          <GeneralTableColumn>{getStatus(vet.snc_status)}</GeneralTableColumn>
          <GeneralTableColumn>{getStatus(vet.community_status)}</GeneralTableColumn>
          <GeneralTableColumn>{getStatus(vet.inspectors_status)}</GeneralTableColumn>
        </>
      )}
    </>
  );
}
